import { useState } from "react";
import AddResourcesForm from "./AddResourcesForm";
import { useDispatch, useSelector } from "react-redux";
import {
  ResourcesLabels,
  GeneralNotificationLabels,
} from "../../../../util/Strings";
import BlackButton from "../../../custom-components/BlackButton";
import CancelButton from "../../../custom-components/CancelButton";
import CloseButton from "../../../custom-components/CloseButton";
import {
  postResource,
  updateResource,
} from "../../../../slices/ResourcesSlice";
import { cancelResUpload } from "../../../../slices/FileUploadSlice";
import { useEffect } from "react";

const ResourcesListForm = ({ show, onClickNext, data, editMode = false }) => {
  const [selectedItem, setSelectedItem] = useState("");
  let updateItem = {};
  const [isUpdateEnabled, setIsUpdateEnabled] = useState(false);
  const selectedOfficeId = useSelector(
    (state) => state.officelist.selectedOfficeId
  );
  const [resources, setResources] = useState([
    {
      _id: data?._id,
      title: data?.title,
      description: data?.description,
      fileStorageId: data?.fileStorageId,
      fileType: data?.fileType,
      fileName: data?.fileName,
      isDeleteAllowed: data?.isDeleteAllowed,
      fileThumbnailUrl: data?.fileThumbnailUrl,
      fileThumbnailName: data?.fileThumbnailName,
      fileUrl: data?.fileUrl,
      thumbNailId: data?.thumbNailId,
      fileId: data?.fileId,
      isValid: false,
    },
  ]);

  const [updatedRes, setUpdatedRes] = useState([]);

  useEffect(() => {
    if (selectedItem) {
      updateItem = { ...selectedItem };
    }
  }, [selectedItem]);

  useEffect(() => {
    const isValid = updatedRes.every((item) => item.isValid);
    setIsUpdateEnabled(isValid);
  }, [updatedRes, selectedItem]);

  const dispatch = useDispatch();

  if (!show) {
    return null;
  }

  const addOrUpdateItem = (newItem) => {
    setUpdatedRes((prevItems) => {
      const index = prevItems.findIndex((item) => item.lId === newItem.lId);
      if (index !== -1) {
        const updatedItems = [...prevItems];
        updatedItems[index] = newItem;
        return updatedItems;
      } else {
        return [...prevItems, newItem];
      }
    });
  };

  const handleUpdateItem = () => {
    if (!editMode) {
      updatedRes.forEach((item) => {
        dispatch(
          postResource({
            id: selectedOfficeId,
            newData: { ...item, officeId: selectedOfficeId },
          })
        );
      });
      dispatch(cancelResUpload());
    } else {
      if (updateItem) {
        dispatch(
          updateResource({
            id: updateItem?._id,
            newData: { ...updateItem, officeId: selectedOfficeId },
          })
        );
      }
    }
    onClickNext();
  };

  return (
    <div className="modal">
      <div className="form-scroll">
        <div className="form-flex" style={{ marginTop: 20, marginBottom: 20 }}>
          <div
            className="user-form-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="form-header">
              <div className="header">
                {GeneralNotificationLabels.uploadFiles}
              </div>
              <CloseButton
                onClickhandle={() => {
                  onClickNext();
                  dispatch(cancelResUpload());
                }}
              />
            </div>
            {resources.map((item, index) => {
              return (
                <AddResourcesForm
                  lId={`File${index}`}
                  data={item}
                  show={show}
                  onClickNext={(newItem) => {
                    if (newItem) {
                      setSelectedItem(newItem);
                      addOrUpdateItem(newItem);
                    }
                  }}
                />
              );
            })}
            <div
              className="footer-button-container"
              style={{ marginRight: 20 }}
            >
              {!editMode && (
                <CancelButton
                  onClickhandle={() => {
                    setResources([...resources, {}]);
                  }}
                >
                  {ResourcesLabels.addAnother}
                </CancelButton>
              )}
              <CancelButton
                onClickhandle={() => {
                  setResources([
                    {
                      _id: data?._id,
                      title: data?.title,
                      description: data?.description,
                      fileStorageId: data?.fileStorageId,
                      fileType: data?.fileType,
                      fileName: data?.fileName,
                      isDeleteAllowed: data?.isDeleteAllowed,
                      fileThumbnailUrl: data?.fileThumbnailUrl,
                      fileThumbnailName: data?.fileThumbnailName,
                      thumbNailId: data?.thumbNailId,
                      fileId: data?.fileId,
                      fileUrl: data?.fileUrl,
                    },
                  ]);
                  dispatch(cancelResUpload());
                  onClickNext();
                }}
              >
                {ResourcesLabels.cancel}
              </CancelButton>
              <BlackButton
                isFromRes={true}
                disabled={isUpdateEnabled}
                onClickhandle={handleUpdateItem}
              >
                {editMode ? ResourcesLabels.update : ResourcesLabels.upload}
              </BlackButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourcesListForm;
